import React, { useState, useEffect } from "react";
import { Container, Row, Col, Modal } from "react-bootstrap";
import { Calender, TextInputForm, DropDownUI } from "../components/Forms";
import { Buttons, ClickButton } from "../components/Buttons";
import { PageHead, PageTitle } from "../components/PageTitle";
import { useNavigate, Navigate, useLocation } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import API_DOMAIN from "../config/config";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment/moment";
import companyId from "../config/companyId";

const ItemCreation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { type, rowData } = location.state || {};
  const initialState =
    type === "edit"
      ? { ...rowData }
      : {
          product_name: "",
        
          hsn_no: "",
          item_code: "",
          unit_id: "",
          subunit_id: "",
          unit_rate: "",
          item_gst: "",
          opening_stock: 0,
          opening_date: moment().format("YYYY-MM-DD"),
          min_stock: 0,
          crt_stock: 0,
        };
  const [formData, setFormData] = useState(initialState);
  const [loading, setLoading] = useState(false);
  const [categoryData, setCategoryData] = useState([]);
  const [unitData, setUnitData] = useState([]);

  const successAlert = (success) => {
    toast.success(success, {
      position: "top-center",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
  };

  const errorAlert = (input) => {
    toast.error(input, {
      position: "top-center",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
  };

  const handleChange = (e, fieldName) => {
    const value = e.target ? e.target.value : e.value;
    setFormData({
      ...formData,
      [fieldName]: value,
    });
  };

  const setLabel = (value, field) => {
    setFormData({
      ...formData,
      [field]: moment(value).format("YYYY-MM-DD"),
    });
  };

  const fetchUnitData = async () => {
    try {
      const response = await fetch(`${API_DOMAIN}/unit.php?id=${companyId}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          search_text: "",
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }

      const responseData = await response.json();
      if (responseData.status === 200) {
        setUnitData(responseData.data);
      } else {
        throw new Error(responseData.msg);
      }
    } catch (error) {
    }
  };

  const fetchCategoryData = async () => {
    try {
      const response = await fetch(
        `${API_DOMAIN}/category.php?id=${companyId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            search_text: "",
          }),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }

      const responseData = await response.json();
      if (responseData.status === 200) {
        setCategoryData(responseData.data);
      } else {
        throw new Error(responseData.msg);
      }
    } catch (error) {
    }
  };

  useEffect(() => {
    fetchUnitData();
    fetchCategoryData();
  }, []);

  const handleSubmit = async () => {
    if (formData.product_name === "") {
      errorAlert("Product Name Is Must");
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(
        `${API_DOMAIN}/products.php?id=${companyId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      const responseData = await response.json();
      console.log("Response Data:", responseData);

      if (responseData.status === 200) {
        setFormData({
          product_name: "",
          hsn_no: "",
          item_code: "",
          unit_id: "",
          subunit_id: "",
          unit_rate: "",
          item_gst: "",
          opening_stock: 0,
          opening_date: moment().format("YYYY-MM-DD"),
          min_stock: 0,
          crt_stock: 0,
        });
        successAlert(responseData.msg);
        setTimeout(() => {
          navigate("/console/item/product");
        }, 2000);
      } else if (responseData.status === 400) {
        errorAlert(responseData.msg);
      } else {
        errorAlert("An error occurred");
      }
    } catch (error) {
      errorAlert("Network error");
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateSubmit = async () => {
    setLoading(true);
    try {
      const updateData = {
        product_id: formData.product_id,
        ...formData,
      };
      const response = await fetch(
        `${API_DOMAIN}/products.php?id=${companyId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(updateData),
        }
      );

      const responseData = await response.json();

      if (responseData.status === 200) {
        successAlert("Product updated successfully!");
        setTimeout(() => {
          navigate("/console/item/product");
        }, 2000);
      } else {
        errorAlert(responseData.msg || "Update failed");
      }
    } catch (error) {
      errorAlert("Network error");
    } finally {
      setLoading(false);
    }
  };

  const [isLoggedIn, setIsLoggedIn] = useState(true);
  useEffect(() => {
    const session = localStorage.getItem("session");
    if (!session) {
      setIsLoggedIn(false);
    }
  }, []);

  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="main p-0 my-3 pt-3">
      <div className="p-2 fixed">
        <PageHead pagehead={<>Add Products</>} onClick={() => navigate(-1)} />
      </div>
      <div className="inside-content p-3">
        <Container fluid>
          <Row>
            <Col lg="4" className="py-3 align-self-center">
              <TextInputForm
                labelname={"Product Name"}
                placeholder={"Product Name"}
                name="product_name"
                value={formData.product_name}
                onChange={(e) => handleChange(e, "product_name")}
              />
            </Col>
            {/* <Col lg="4" className="py-3 align-self-center">
              <TextInputForm
                labelname={"HSN No"}
                placeholder={"HSN No"}
                name="hsn_no"
                value={formData.hsn_no}
                onChange={(e) => handleChange(e, "hsn_no")}
              />
            </Col> */}
            {/* <Col lg="4" className="py-3 align-self-center">
              <TextInputForm
                labelname={"Item Code"}
                placeholder={"Item Code"}
                name="item_code"
                value={formData.item_code}
                onChange={(e) => handleChange(e, "item_code")}
              />
            </Col> */}
            {/* <Col lg="4" className="align-self-center py-3">
              <DropDownUI
                optionlist={categoryData.map((user) => ({
                  value: user.category_id,
                  label: user.category_name,
                }))}
                placeholder="Category"
                labelname="Category"
                name="category_id"
                value={formData.category_id}
                onChange={(updatedFormData) =>
                  setFormData({
                    ...formData,
                    category_id: updatedFormData.category_id,
                  })
                }
              />
            </Col> */}
            <Col lg="4" className="py-3">
              <DropDownUI
                optionlist={unitData.map((user) => ({
                  value: user.unit_id,
                  label: user.unit_name,
                }))}
                placeholder="Select"
                labelname="Unit"
                name="unit_id"
                value={formData.unit_id}
                onChange={(updatedFormData) =>
                  setFormData({
                    ...formData,
                    unit_id: updatedFormData.unit_id,
                  })
                }
              />
            </Col>
            {/* <Col lg="4" className="py-3">
              <DropDownUI
                optionlist={unitData.map((user) => ({
                  value: user.unit_id,
                  label: user.unit_name,
                }))}
                placeholder="Sub Unit (Optional)"
                labelname="Sub Unit"
                name="subunit_id"
                value={formData.subunit_id}
                onChange={(updatedFormData) =>
                  setFormData({
                    ...formData,
                    subunit_id: updatedFormData.subunit_id,
                  })
                }
              />
            </Col> */}
            <Col lg="4" className="py-3 align-self-center">
              <TextInputForm
                labelname={"Sale Rate"}
                placeholder={"Sale Rate"}
                name="unit_rate"
                value={formData.unit_rate}
                onChange={(e) => handleChange(e, "unit_rate")}
              />
            </Col>
            {/* <Col lg="4" className="py-3 align-self-center">
              <TextInputForm
                labelname={"Item GST"}
                placeholder={"Item GST"}
                name="item_gst"
                value={formData.item_gst}
                onChange={(e) => handleChange(e, "item_gst")}
              />
            </Col> */}
            {/* <Col lg="4" className="py-3 align-self-center">
              <TextInputForm
                labelname={"Opening Stock"}
                placeholder={"Opening Stock"}
                name="opening_stock"
                value={formData.opening_stock}
                onChange={(e) => handleChange(e, "opening_stock")}
                type="number"
              />
            </Col> */}
            {/* <Col lg="4" className="py-3 align-self-center">
              <TextInputForm
                labelname={"Min Stock"}
                placeholder={"Min Stock"}
                name="min_stock"
                value={formData.min_stock}
                onChange={(e) => handleChange(e, "min_stock")}
                type="number"
              />
            </Col> */}
            {/* <Col lg="4" className="py-3 align-self-center">
              <TextInputForm
                labelname={"Current Stock"}
                placeholder={"Current Stock"}
                name="crt_stock"
                value={formData.crt_stock}
                onChange={(e) => handleChange(e, "crt_stock")}
                type="number"
              />
            </Col> */}
            {/* <Col lg="4" className="py-3 align-self-center">
              <Calender
                textlabel="Opening Date"
                value={formData.opening_date}
                onChange={(date) => setLabel(date, "opening_date")}
              />
            </Col> */}
          </Row>
        </Container>
        <div className="text-center py-3">
          <ToastContainer
            position="bottom-center"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
          />
          <span className="mx-2">
            <ClickButton
              label={type === "edit" ? <>Update</> : <>Submit</>}
              onClick={type === "edit" ? handleUpdateSubmit : handleSubmit}
              disabled={loading}
            />
          </span>
          <span className="mx-2">
            <ClickButton
              label={<>Cancel</>}
              onClick={() => navigate("/console/item/product")}
            />
          </span>
        </div>
      </div>
    </div>
  );
};

export default ItemCreation;

